export const zIndexMap = {
  sidebarMenu: 10,
  popover: 120,
  banner: 150,
}